mutation updateCompanyTheme($input: UpdateCompanyThemeInput!) {
  updateCompanyTheme(input: $input) {
    colors {
      primary
      secondary
    }
  }
}
